import { BASE_APP_PATH, NOT_AUTH_PAGES } from "../constants/routes.constants";
import { clearErrorAndCheck404 } from "./error.helpers";
import { checkWidth, collapseMainContainer, hideAppsContainer, show404Error, showAppsContainer, } from "./ui.helpers";
export function addTitleChangeListener() {
    window.addEventListener("title:change", (e) => {
        const title = (e && e.detail && e.detail.title) || "";
        const titleEl = document.getElementById("moex-platform-app-title");
        if (titleEl) {
            titleEl.innerHTML = title.length ? `<p>${title}</p>` : "";
        }
    });
}
export function setTitle(menuData) {
    if (!menuData || !menuData.menus || !menuData.cabinets)
        return;
    if (location.pathname === "/") {
        localStorage.setItem("mb-title", "");
        return;
    }
    let currentName = "";
    const KEYWORDS = ["hamburger", "list", "children", "vertical_menus"];
    const notValidSPAlink = (url) => !url || (url && !url.startsWith("/"));
    const parseLink = (menuLinks, urlKeyName, titleKey) => {
        if (currentName)
            return;
        for (const item of menuLinks) {
            for (const key of KEYWORDS) {
                if (!item[key] || !item[key].length)
                    continue;
                const page = item[key].find((link) => {
                    parseLink(item[key], urlKeyName, titleKey);
                    if (notValidSPAlink(link[urlKeyName]))
                        return;
                    return (link[urlKeyName] && location.pathname.endsWith(link[urlKeyName]));
                });
                if (page) {
                    currentName = page[titleKey];
                    return;
                }
            }
        }
    };
    parseLink(menuData.menus, "path", "title");
    parseLink(menuData.cabinets, "url", "title");
    parseLink(menuData.products, "url", "title");
    parseLink(menuData.aside, "link", "label");
    localStorage.setItem("mb-title", currentName);
}
export function addIncapsulatedAppsWatcher(incapsulatedAppsCodes) {
    window.addEventListener("single-spa:app-change", (e) => {
        if (e.detail.appsByNewStatus.NOT_MOUNTED.some((appName) => !incapsulatedAppsCodes.some((appCode) => appName.endsWith(appCode)))) {
            window.location.reload();
        }
    });
}
export function addEventListeners(applicationsList, menuData) {
    window.addEventListener("single-spa:routing-event", (e) => {
        const oldUrl = e.detail?.oldUrl;
        setTitle(menuData);
        // TODO: Remove next line when SPA routing comes instead of MPA routing
        if (e.detail?.originalEvent?.type === "popstate" &&
            oldUrl &&
            NOT_AUTH_PAGES.some((path) => oldUrl.includes(path))) {
            window.location.reload();
        }
        if (window.location.pathname !== BASE_APP_PATH) {
            showAppsContainer();
        }
        collapseMainContainer();
        show404Error();
        checkWidth(applicationsList);
    });
    window.addEventListener("single-spa:before-routing-event", () => {
        hideAppsContainer();
        clearErrorAndCheck404();
        setTitle(menuData);
    });
}
